const DrawDate = () => {
  const today = new Date();
  const future = new Date(today); // создаём копию
  future.setDate(today.getDate() + 3); // прибавляем 3 дня

  const options = {
    weekday: 'long',  // e.g. "Tuesday"
    month: 'long',    // e.g. "May"
    day: 'numeric'    // e.g. "13"
  };

  const formattedDate = future.toLocaleDateString('en-US', options);

  return <p className="col-white">{formattedDate}</p>;
};
export default DrawDate;
